import { render, staticRenderFns } from "./Residents.vue?vue&type=template&id=3d015370"
import script from "./Residents.vue?vue&type=script&lang=ts"
export * from "./Residents.vue?vue&type=script&lang=ts"
import style0 from "./Residents.vue?vue&type=style&index=0&id=3d015370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports